<template>
<div>
    <Partials message="Acceso no autorizado"/>
</div>
</template>

<script>
import Partials from '@/views/student/constants/errors/partials/button.vue'

export default {
    components: {
    Partials,
  },
}
</script>
